import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRainyLight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRainyLight"><Path d="M9.42188 3C5.86553 3 3 5.91986 3 9.5C3 13.0801 5.86553 16 9.42188 16H10.2851L9.24219 18.0858L10.5838 18.7566L11.9621 16H16.125C18.827 16 21 13.7822 21 11.0682C21 8.35412 18.827 6.13636 16.125 6.13636C15.7367 6.13636 15.3585 6.18243 14.9956 6.26957C13.8902 4.32006 11.8116 3 9.42188 3Z" fill="currentColor"/><Path d="M12.8338 21.5066L14.5046 18.165L13.163 17.4941L11.4922 20.8358L12.8338 21.5066Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRainyLight;
